import { userActions } from '../_actions'
import { apiService } from '.'

export const userService = {
  updateUser,
  forgotPassword,
  login,
  logout,
  resetPasswordValid,
  resetPasswordChange,
  getUser,
  getUserByPage,
  activeUser,
  addUser,
  getUserById,
  checkOldAndNewPassword,
  getJustLookingUserById,
  checkOldAndNewPasswordMaptoolx
}
function login(userName,password){
  return apiService.fetchLogin('users/login',{emailAddress:userName, password:password})
    .then(response => {
      console.log(response)
      return apiService.handleResponse(response)
    })
    .catch(error => {
      return error
    })
}
function forgotPassword(emailAddress){
  return apiService.fetchWithoutAuthGet('users/forgot-password?emailAddress='+emailAddress)
    .then(response => {
      console.log(response)
      return apiService.handleResponse(response)
    })
    .catch(error => {
      return error
    })
}
function logout(){
  return apiService.fetchAuthPost('users/logout',{token:userActions.getCurrentToken()})
    .then(response => {
      console.log(response)
      return apiService.handleResponse(response)
    })
    .catch(error => {
      return error
    })
}

function resetPasswordValid(objRequest){
  return apiService.fetchWithoutAuthPost('users/reset-password-valid',objRequest)
    .then(response => {
      console.log(response)
      return apiService.handleResponse(response)
    })
    .catch(error => {
      return error
    })
}

function resetPasswordChange(objRequest){
  return apiService.fetchWithoutAuthPost('users/reset-password-change',objRequest)
    .then(response => {
      console.log(response)
      return apiService.handleResponse(response)
    })
    .catch(error => {
      return error
    })
}

function getUser(){
  return apiService.fetchAuthGet('user')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getUserByPage(start, pageSize, search) {
  return apiService.fetchAuthGet('users/page?start=' + start + '&pageSize=' + pageSize + '&search=' + search)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function activeUser(id,isActive){
  return apiService.fetchAuthPut('users/active/'+id+'/'+(isActive?1:0),{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function addUser(user) {
  return apiService.fetchAuthPost('users/adduser', user)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getUserById(id) {
  return apiService.fetchAuthGet('users/' + id)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function updateUser(user, id) {
  return apiService.fetchAuthPut('users/' + id, user)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function checkOldAndNewPassword(currentUserIdComp, backOfficeOldPassword, backOfficeNewPassword) {
  return apiService.fetchAuthPut('users/update-password-backoffice/' + currentUserIdComp, {'password':backOfficeNewPassword})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getJustLookingUserById(id) {
  return apiService.fetchAuthGet('users/' + id)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function checkOldAndNewPasswordMaptoolx(maptoolxFixedId, maptoolxUserName, maptoolxOldPassword, maptoolxNewPassword) {
  return apiService.fetchAuthGet('users/update-password-maptoolx?maptoolxFixedId=' + maptoolxFixedId + '&maptoolxUserName=' + maptoolxUserName + '&maptoolxOldPassword=' + maptoolxOldPassword + '&maptoolxNewPassword=' + maptoolxNewPassword)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
